export const DefaultTheme = {
  colors: {
    backgroundColor: '#EDEDF0',
    mainColor: '#111',
    subColor: '#DDD',
    fontColor: '#333',
  },
};
